import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAddressLine implements BaseEnumType {
  private static allValues: EnumAddressLine[] = []; // make sure this is top-most
  
  public static none = new EnumAddressLine(0, "None", "enum_address_line_none");
  public static street1 = new EnumAddressLine(1, "Street1", "enum_address_line_street1");
  public static street2 = new EnumAddressLine(2, "Street2", "enum_address_line_street2");
  public static street3 = new EnumAddressLine(3, "Street3", "enum_address_line_street3");
  public static townCity = new EnumAddressLine(4, "TownCity", "enum_address_line_town_city");
  public static province = new EnumAddressLine(5, "Province", "enum_address_line_province");
  public static country = new EnumAddressLine(6, "Country", "enum_address_line_country");
  public static postcode = new EnumAddressLine(7, "Postcode", "enum_address_line_postcode");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAddressLine.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumAddressLine.none; }
  public isStreet1() { return this === EnumAddressLine.street1; }
  public isStreet2() { return this === EnumAddressLine.street2; }
  public isStreet3() { return this === EnumAddressLine.street3; }
  public isTownCity() { return this === EnumAddressLine.townCity; }
  public isProvince() { return this === EnumAddressLine.province; }
  public isCountry() { return this === EnumAddressLine.country; }
  public isPostcode() { return this === EnumAddressLine.postcode; }

  public static getValues(): readonly EnumAddressLine[] {
    return EnumAddressLine.allValues;
  }

  public static getValuesExcept0(): readonly EnumAddressLine[] {
    return EnumAddressLine.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAddressLine {
    const found = EnumAddressLine.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAddressLine - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAddressLine): EnumAddressLine {
    const found = name ? EnumAddressLine.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAddressLine - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAddressLine>): boolean {
    return this.key === other?.key;
  }
}